import { BUILDING_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormDefaults";
import type { HouseFormInput } from "web_myplann/Portfolio/Forms/HouseForm/houseFormSchema";

export const HOUSE_FORM_DEFAULT_VALUES: HouseFormInput =
	BUILDING_FORM_DEFAULT_VALUES;
